/**
 * @author gha
 * @version 0.1  2008-02-10
 * @package dcms
 * @internal tabsize 2 (no spaces)
 *
 * @settings
 * startCollapsed (boolean, false): collapse all branches by default
 * expandRoot (boolean, false): only in combination with startCollapsed=true
 * cookie (string, 'auto'): Save tree state in a cookie
 *
 * Last changes:
 * 2008-02-08 - gha - initial version
 * 2008-02-13 - gha - additional parameter expandRoot
 * 2008-02-25 - gha - only one cookie for all trees
 * 2020-05-25 - gha - Replace usage of cookies by local storage
 */
(function ($) {

    let Tree_Obj;
    let Tree_branches;
    let Cookie_Name = '';

    $.extend($.fn, {
        DCMS_prepare: function (settings) {
            // Letzte LIs behandeln
            this.filter(':last-child').addClass('lastChild');

            // Hitareas einfuegen (Default: empty)
            this.prepend('<span class="empty"></span>');

            // Aeste ermitteln
            let b = this.filter(":has(>ul)");

            // Initialisierung umsetzen
            if (settings.startCollapsed) {
                b.DCMS_closeBranch();
                // Root-Branch aufklappen, falls gewuenscht
                if (settings.expandRoot && b.eq(0).siblings().length === 0) {
                    b.eq(0).DCMS_openBranch();
                }
            } else {
                b.DCMS_openBranch();
            }

            // Aeste zurueckliefern
            return b;
        },
        DCMS_Tree: function (settings) {
            // CONTEXT: jQuery-Objekt; initialisierungs-ID
            Tree_Obj = this;

            // Setting-Defaults
            settings.startCollapsed = settings.startCollapsed || false;
            settings.expandRoot = settings.expandRoot || false;
            settings.forceOpen = settings.forceOpen || 0;
            Cookie_Name = settings.cookie || '';

            if (Cookie_Name === 'auto') {
                SID.split('=');
                //Cookie_Name = Tree_Obj.attr('class')+'_'+sess_array[1];
                Cookie_Name = Tree_Obj.attr('class');
                Tree_Obj.attr('id');
                //alert(Cookie_Name + ' ' + Cookie_Sect);
            }

            // Aufklappbare Aeste ermitteln (->jQuery-Obj)
            Tree_branches = $('li', this).DCMS_prepare(settings);

            // Click-Events registrieren
            Tree_branches.DCMS_click();

            // Ggf. Status auslesen und setzen
            if (Cookie_Name !== '') {
                this.DCMS_restoreState();
            }

            // Ggf. bestimmten Zweig öffnen
            if (settings.forceOpen > 0) {
                $('li[data-tree-node-id=' + settings.forceOpen + ']', this).DCMS_openBranchRecursive();
            }

        },
        DCMS_toggleBranch: function () {

            // aufklappen, wenn zugeklappt; zuklappen, wenn aufgeklappt
            let li = this.parent();
            if ($('>ul', li).css('display') === 'none') {
                // Aufklappen
                li.DCMS_openBranch();
            } else {
                // Zuklappen
                li.DCMS_closeBranch();
            }
            //alert(outputObject(Tree_branches));
            Tree_Obj.DCMS_saveState();
        },
        DCMS_openBranch: function () {
            // Aufklappen
            $('>ul', this).show();
            $('>span', this).removeClass('closed').addClass('opened');
        },
        DCMS_openBranchRecursive: function () {
            $(this).parents('li').DCMS_openBranch();
            if ($(this).hasClass('DCMS_nodeHasChildren')) {
                $(this).DCMS_openBranch();
            }
            Tree_Obj.DCMS_saveState();
        },
        DCMS_closeBranch: function () {
            // Zuklappen
            $('>ul', this).hide();
            $('>span', this).removeClass('opened').addClass('closed');
        },
        DCMS_saveState: function () {
            let idx;
            const stateArray = [];
            let treeArray = [];
            let treeName = Tree_Obj.attr('id');
            //var cookieVal = $.cookie(Cookie_Name);
            const cookieVal = localStorage[Cookie_Name];

            for (idx = 0; idx < Tree_branches.length; idx++) {
                stateArray[idx] = ($('>ul', Tree_branches[idx]).css('display') === 'none' ? 0 : 1);
            }
            if (cookieVal != null) {
                treeArray = cookieVal.split(';');
                if (cookieVal.indexOf(treeName) >= 0) {
                    // Enthalten
                    for (const treeKey in treeArray) {
                        if (treeArray.hasOwnProperty(treeKey)) {
                            treeName = treeArray[treeKey].split('=')[0];
                            let treeVal = treeArray[treeKey].split('=')[1];
                            if (treeName === Tree_Obj.attr('id')) {
                                treeVal = stateArray.join('');
                            }
                            treeArray[treeKey] = treeName + '=' + treeVal;
                        }
                    }

                } else {
                    // nicht enthalten
                    treeArray.push(treeName + '=' + stateArray.join(''));
                }

            } else {
                treeArray[0] = treeName + '=' + stateArray.join('');
            }
            if (Cookie_Name !== '') {
                //$.cookie(Cookie_Name, treeArray.join(';'));
                localStorage.setItem(Cookie_Name, treeArray.join(';'))
            }
        },
        DCMS_restoreState: function () {
            //var cookieVal  = $.cookie(Cookie_Name);
            const cookieVal = localStorage[Cookie_Name];
            let treeName = Tree_Obj.attr('id');
            let state;
            if (cookieVal != null) {
                let treeArray = cookieVal.split(';');
                if (cookieVal.indexOf(treeName) >= 0) {
                    // Enthalten
                    for (const treeKey in treeArray) {
                        if (treeArray.hasOwnProperty(treeKey)) {
                            treeName = treeArray[treeKey].split('=')[0];
                            const stateArray = treeArray[treeKey].split('=')[1];
                            if (treeName === Tree_Obj.attr('id') && stateArray != null) {
                                for (let idx = 0; idx < stateArray.length; idx++) {
                                    state = stateArray.charAt(idx);
                                    switch (state) {
                                        case "0":
                                            Tree_branches.eq(idx).DCMS_closeBranch();
                                            break;
                                        case "1":
                                            Tree_branches.eq(idx).DCMS_openBranch();
                                            break;
                                    }
                                }
                            }
                        }
                    }
                }
            }
            Tree_Obj.DCMS_saveState();
        },
        DCMS_click: function () {
            // Click-Events registrieren
            // Hier: Fallback vom jQuery-Obj auf ein HTML-Obj
            $('span.opened, span.closed', this).click(
                function (e) {
                    // printObj(e.target);
                    $(e.target).DCMS_toggleBranch();
                }
            );
        }
    });
})(jQuery);
